function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  width: 512,
  height: 512
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "256,255.998 85.334,511.994 106.321,511.994 276.988,255.998 106.321,0 85.334,0 "
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function Svg242Zimbabwe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.302,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 73.301
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 366.512,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 73.302
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 73.302
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.608,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 73.301
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 293.207,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 73.301
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 439.806,
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 72.188
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "276.992,255.998 106.329,511.989 0,511.989 0,0.006 106.329,0.006 "
  }), _ref3, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "102.463,171.313 123.482,236.003 191.509,236.003 136.477,275.989 157.496,340.683   102.463,300.7 47.431,340.683 68.453,275.989 13.422,236.003 81.444,236.003 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M160.28,261.29l-54.778-19.407c0,0-4.048-37.97-4.292-39.257c-1.859-9.795-10.465-17.2-20.799-17.2  c-11.693,0-21.171,9.479-21.171,21.171c0,1.939,0.283,3.807,0.77,5.592l-15.359,15.462c0,0,18.243,0,27.309,0  c0,28.346-21.152,28.346-21.152,56.574l11.733,28.228h70.571l11.764-28.228h-0.007c1.179-2.708,1.892-5.501,2.189-8.293  C157.197,271.832,160.28,261.29,160.28,261.29z"
  }), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg242Zimbabwe);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };